<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    @click:outside="$emit('changeValue', false)"
    @keydown="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <slot name="body" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="$emit('changeValue', false)">Cancelar</v-btn>
        <v-btn :loading="loading" color="green darken-1" text @click="$emit('processar', false)">Processar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
      showDialog: {
        type: Boolean,
        required: true
      }
    },

    emits: ['changeValue', 'processar'],

    data() {
      return {
        dialog: false
      };
    },

    watch: {
      showDialog(newValue) {
        this.dialog = newValue;
      }
    }
  };
</script>
